/**
  Author: Lokesh Arora - lokesh.arora@enabledata.com
  Purpose: Users services
  Date: April 2020
**/

import API from '../utils/api';
import LocalStorageService from './localStorage';

export const getUserList = (orgsId) => {
  const queryString = orgsId ? `?orgs_id=${encodeURIComponent(orgsId)}` : ``;
  return API.get(`users/users${queryString}`, {
    headers: {
      Authorization: `Bearer ${LocalStorageService.getAccessToken()}`,
    },
  });
};

export const getUserListForReport = (orgsId) => {
  const queryString = orgsId ? `&orgs_id=${encodeURIComponent(orgsId)}` : ``;
  return API.get(`users/users?purpose=listing${queryString}`, {
    headers: {
      Authorization: `Bearer ${LocalStorageService.getAccessToken()}`,
    },
  });
};

export const getUser = (id) => {
  return API.get(`users/users/${encodeURIComponent(id)}`, {
    headers: {
      Authorization: `Bearer ${LocalStorageService.getAccessToken()}`,
    },
  });
};

export const addUser = (data) => {
  return API.post(`users/users`, data, {
    headers: {
      Authorization: `Bearer ${LocalStorageService.getAccessToken()}`,
    },
  });
};

export const updateUser = (data) => {
  return API.put(`users/users/${encodeURIComponent(data.PK)}`, data, {
    headers: {
      Authorization: `Bearer ${LocalStorageService.getAccessToken()}`,
    },
  });
};
export const updateUserStatus = (data) => {
  return API.post(`settings/patch/users`, data, {
    headers: {
      Authorization: `Bearer ${LocalStorageService.getAccessToken()}`,
    },
  });
};

export const getProductRoles = (orgsId) => {
  return API.get(`users/users/products/${encodeURIComponent(orgsId)}`, {
    headers: {
      Authorization: `Bearer ${LocalStorageService.getAccessToken()}`,
    },
  });
}
export const updateUserRole = (userId) => {
  return API.put(`users/root/${encodeURIComponent(userId)}`, {}, {
    headers: {
      Authorization: `Bearer ${LocalStorageService.getAccessToken()}`,
    },
  });
};